export enum MercerPositionType {
  None = 'None',
  LiftDropReview = 'LiftDropReview',
  LiftDropPlace = 'LiftDropPlace',
  Merged = 'Merged',
  New = 'New'
}
